<template>
	<el-tabs type="border-card">
		<el-tab-pane label="设置公众号信息">
			<el-form :model="shu">
				<el-form-item label="名称" label-width="180px">
					<el-input v-model="shu.mingcheng" placeholder="公众号名称"></el-input>
				</el-form-item>
				<el-form-item label="简介" label-width="180px">
					<el-input v-model="shu.miaoshu" placeholder="公众号简介"></el-input>
				</el-form-item>
				<el-form-item label="微信号" label-width="180px">
					<el-input v-model="shu.zhanghao" placeholder="微信号,非必填"></el-input>
				</el-form-item>
				<el-form-item label="原始ID" label-width="180px">
					<el-input v-model="shu.yuanshiid" placeholder="原始ID"></el-input>
				</el-form-item>
				<el-form-item label="公众号类型" label-width="180px">
					<el-radio-group v-model="shu.leixing">
						<el-radio label="1">认证服务号</el-radio>
						<el-radio label="2">认证订阅号</el-radio>
						<el-radio label="3">普通服务号</el-radio>
						<el-radio label="4">普通订阅号</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="AppId" label-width="180px">
					<el-input v-model="shu.appid" placeholder="AppId"></el-input>
				</el-form-item>
				<el-form-item label="AppSecret" label-width="180px">
					<el-input v-model="shu.appsecret" placeholder="AppSecret"></el-input>
				</el-form-item>
				<el-form-item label="Token" label-width="180px">
					<el-input v-model="shu.token" placeholder="Token"></el-input>
				</el-form-item>
				<el-form-item label="EncodingAESKey" label-width="180px">
					<el-input v-model="shu.encodingaeskey" placeholder="EncodingAESKey">
						<el-button slot="append" @click="Suijizifu(shu)">一键生成</el-button>
					</el-input>
				</el-form-item>
				<el-form-item label="上传验证文件" label-width="180px">
					<Shangwenjian v-model="shu.yanzhengwenjian" leixing="teshu" anniu="选择文件"></Shangwenjian>
				</el-form-item>
				<el-form-item label="二维码" label-width="180px">
					<Shangwenjian v-model="shu.erweima" anniu="选择图片" leixing="tu"></Shangwenjian>
				</el-form-item>
				<el-form-item label="Logo" label-width="180px">
					<Shangwenjian v-model="shu.touxiang" anniu="选择图片" leixing="tu"></Shangwenjian>
				</el-form-item>
				<el-form-item label-width="180px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-tab-pane>
		<el-tab-pane label="引导页面" style="padding: 10px;">
			<el-tag style="width: 100%;">您绑定的微信公众号：<span class="jiacu">{{shu.mingcheng}}</span>请按照下列引导完成配置。</el-tag>
			<el-timeline style="margin-top: 40px;">
				<el-timeline-item timestamp="01" placement="top">
					<el-card>
						<p>登录<a target="_blank" href="https://mp.weixin.qq.com/" style="margin: -6px 10px 0 10px;">微信公众平台</a>
							点击左侧菜单最后一项，进入
							<span class="yanse">[ 开发者中心 ]</span> </p>
					</el-card>
				</el-timeline-item>
				<el-timeline-item timestamp="02" placement="top">
					<el-card>
						<p>在开发者中心，找到 <span class="yanse">[ 服务器配置 ]</span>栏目下URL和Token设置</p>
						<p style="margin-left: 10px;">#将以下链接填入对应输入框</p>
						<el-form ref="form">
							<el-form-item label="IP白名单:" label-width="180px">
								<div class="shuju" @click="copyLink" data-clipboard-action="copy"  :data-clipboard-text="shu.ip">{{shu.ip}}</div>
							</el-form-item>
							<el-form-item label="URL:" label-width="180px">
								<div class="shuju" @click="copyLink" data-clipboard-action="copy"  :data-clipboard-text="shu.url">{{shu.url}}</div>
							</el-form-item>
							<el-form-item label="Token:" label-width="180px">
								<div class="shuju" @click="copyLink" data-clipboard-action="copy"  :data-clipboard-text="shu.token">{{shu.token}}</div>
							</el-form-item>
							<el-form-item label="EncodingAESKey:" label-width="180px">
								<div class="shuju"  @click="copyLink" data-clipboard-action="copy"  :data-clipboard-text="shu.encodingaeskey">{{shu.encodingaeskey}}</div>
							</el-form-item>
						</el-form>
						<p class="p">#如果以前已填写过URL和Token，请点击 <span class="yanse">[ 修改配置 ]</span>，再填写上述链接</p>
						<p class="p">#请点击 <span class="yanse">[启用]</span>，以启用服务器配置</p>
					</el-card>
				</el-timeline-item>
			</el-timeline>
		</el-tab-pane>

	</el-tabs>
</template>

<script>
	let that;
	import Shangwenjian from '../../zujian/Shangwenjian.vue'
	export default {
		data() {
			return {
				shu: {
					leixing: 1,
					qita: {
						yanzhengwenjian: ''
					}
				},			
			}
		},
		created() {
			that = this;
			this.CSH();
		},
		components: {
			Shangwenjian
		},
		methods: {
			CSH() {
				this.$post('k=peizhi&c=gongzhonghao', function(s) {
					if (s.shi == 1) {
						that.shu = s.shu;
					}

				});
			},
			Suijizifu(e) {
				this.$set(e, 'encodingaeskey', this.$suijizifu())
			},
			Tijiao() {
				this.$post('k=peizhi&c=gongzhonghao_xiugai', this.shu, function(s) {
					that.$xiaoxi(s.shu);
					if (s.shi == 1) {
						that.CSH();
					}
				});
			},
			copyLink() {
			   let _this = this;
			   let clipboard = new this.clipboard(".shuju");
			   clipboard.on('success', function () {
			   alert("复制成功")
			   });
			   clipboard.on('error', function () {
			   alert("复制失败")
			   });
			 }
		}
	}
</script>

<style>
	.tishi {
		color: #737373;
	}

	.yanse {
		color: #1ab667;
	}

	.tip {
		position: relative;
		background-color: deepskyblue;
		margin: -150px auto 0 0;
		width: 246px;
		height: 43px;
		line-height: 43px;
		color: white;
		text-align: center;
		border-radius: 10px;
		font-family: sans-serif;
	}

	.tip:after {
		content: '';
		position: absolute;
		width: 0;
		height: 0;
		border: 8px solid;
	}

	.left:after {
		border-right-color: deepskyblue;
		top: 50%;
		right: 100%;
		margin-top: -9px;
	}

	.shuju {
		color: #ff0000;
	}

	p {
		color: #788188;
	}

	.p {
		margin-left: 40px;
	}

	.jiacu {
		color: #950000;
		font-weight: bold;
		margin: 0 6px;
	}
</style>
